import React from "react";

export default function BackgroundWrapper(props) {
    // if(props.currentStep == -1){
    //     return (
    //         <div className="menopause-test-wrapper welcome-bg">
    //             {props.children}
    //         </div>
    //     )
    // }else{
        return (
            <div className="menopause-test-wrapper" style={{background: `url(${props.image})`}}>
                {props.children}
            </div>
        )
    // }
}